export default "__VITE_ASSET__d215a4a3__"